// Function to Add 20% VAT on Toggle on an Remove 20% VAT on Toggle Off (Change)

if (performance.navigation.type == 2) {
  location.reload(true);
}
var checkbox = document.getElementById("vat-toggle");
function checkBoxToggle() {
  if (checkbox.checked) {
    localStorage.setItem("VatToggle", checkbox.checked);
    functionChecked();
  } else {
    localStorage.setItem("VatToggle", false);
    functionUnchecked();
  }
}

// load
document.onload = bodyload();

function bodyload() {
  if (window.location.href.includes("/collections/")) {
    bodyloadForCollection();
  } else {
    const price = document.getElementsByClassName("custom_price");
    const mainPrice = document.getElementsByClassName("custom_main_price");
    for (let j = 0; j < mainPrice.length; j++) {
      const currentURL = window.location.href;
      if (currentURL.includes("/products/")) {
        setTimeout(() => {
          const VatToggle = localStorage.getItem("VatToggle") || "true";
          if (VatToggle == "true") {
            checkbox.checked = true;
            functionForChecked();
          } else {
            checkbox.removeAttribute("checked");
            functionForUnchecked();
          }
        }, 2000);
      } else {
        const VatToggle = localStorage.getItem("VatToggle") || "true";
        if (VatToggle == "true") {
          checkbox.checked = true;
          functionForChecked();
        } else {
          checkbox.removeAttribute("checked");
          functionForUnchecked();
        }
      }
    }
  }
}

// for collection page only to give a delay
function bodyloadForCollection() {
  setTimeout(() => {
    const price = document.getElementsByClassName("custom_price");
    const mainPrice = document.getElementsByClassName("custom_main_price");
    for (let j = 0; j < mainPrice.length; j++) {
      const currentURL = window.location.href;
      if (currentURL.includes("/products/")) {
        setTimeout(() => {
          const VatToggle = localStorage.getItem("VatToggle") || "true";
          if (VatToggle == "true") {
            checkbox.checked = true;
            functionForChecked();
          } else {
            checkbox.removeAttribute("checked");
            functionForUnchecked();
          }
        }, 2000);
      } else {
        const VatToggle = localStorage.getItem("VatToggle") || "true";
        if (VatToggle == "true") {
          checkbox.checked = true;
          functionForChecked();
        } else {
          checkbox.removeAttribute("checked");
          functionForUnchecked();
        }
      }
    }
  }, 2000);
}

function modalLoad() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");
  for (let j = 0; j < mainPrice.length; j++) {
    const currentURL = window.location.href;
    if (currentURL.includes("/products/")) {
      setTimeout(() => {
        const VatToggle = localStorage.getItem("VatToggle") || "true";
        if (VatToggle == "true") {
          checkbox.checked = true;
          functionForChecked();
        } else {
          checkbox.removeAttribute("checked");
          functionForUnchecked();
        }
      }, 1800);
    } else {
      const VatToggle = localStorage.getItem("VatToggle") || "true";
      if (VatToggle == "true") {
        checkbox.checked = true;
        functionForChecked();
      } else {
        checkbox.removeAttribute("checked");
        functionForUnchecked();
      }
    }
  }
}

//when recommended products load
function recommendedProductLoad() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");
  for (let j = 0; j < mainPrice.length; j++) {
    setTimeout(() => {
      const VatToggle = localStorage.getItem("VatToggle") || "true";
      if (VatToggle == "true") {
        checkbox.checked = true;
        functionForChecked();
      } else {
        checkbox.removeAttribute("checked");
        functionForUnchecked();
      }
    }, 3000);
  }
}
// on quantity change
function bodyload1() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");
  setTimeout(() => {
    const VatToggle = localStorage.getItem("VatToggle") || "true";
    if (VatToggle == "true") {
      checkbox.checked = true;
      functionForChecked();
    } else {
      checkbox.removeAttribute("checked");
      functionForUnchecked();
    }
  }, 2000);
}
function functionForUnchecked() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");
  // setTimeout(()=>{

  for (let j = 0; j < mainPrice.length; j++) {
    const mainDataValue = mainPrice[j]?.dataset?.mainprice
      ?.slice(1)
      .replace(/,|\./g, function (match) {
        return match === "," ? "." : "";
      });
    const mainPriceExcludedVAT = parseFloat(
      (mainDataValue * 100) / 121
    ).toFixed(2);
    // setTimeout(() => {

    const isMeta = mainPrice[j]?.dataset?.ismeta;
    const ism2 = mainPrice[j]?.dataset?.ism2;

    if (isMeta == "true") {
      const metaVal = mainPrice[j]?.dataset?.metaval
        ?.slice(1)
        .replace(/,|\./g, function (match) {
          return match === "," ? "." : "";
        });

      const metaValReplaced = metaVal.replace(".", ",");

      mainPrice[
        j
      ].innerHTML = `€${metaValReplaced} <span>per m<sup>2</sup></span>`;
    } else {
      const dataTest = price[j]?.dataset?.test;
      if (ism2 == "true") {
        mainPrice[j].innerHTML = `€ ${mainPriceExcludedVAT?.replace(
          ".",
          ","
        )} per m<sup>2</sup> <span class="excl"> (excl. BTW)</span>`;
      } else {
        mainPrice[j].innerHTML = `€ ${mainPriceExcludedVAT?.replace(
          ".",
          ","
        )} <span class="excl"> (excl. BTW)</span>`;
      }

      // }, 1500);
    }
  }
  // },2000);    mine

  for (let i = 0; i < price.length; i++) {
    const ism2 = mainPrice[i]?.dataset?.ism2;
    const dataValue = price[i]?.dataset?.price?.slice(1)?.replace(",", ".");
    const priceExcludedVAT = parseFloat((dataValue * 100) / 121).toFixed(2);
    // setTimeout(() => {
    const dataTest = price[i]?.dataset?.test;
    if (dataTest === "test") {
      // if(ism2=="true"){
      //   const dataUnit = document.getElementById("custom_unit").dataset.unit;
      // price[i].innerHTML = `€${priceExcludedVAT?.replace(
      //   ".",
      //   ","
      // )} <span class="excl">(excl. BTW)</span><span aria-hidden="true">/</span> ${dataUnit} per m<sup>2</sup>`;
      // }else{
      const dataUnit = document.getElementById("custom_unit").dataset.unit;
      price[i].innerHTML = `€${priceExcludedVAT?.replace(
        ".",
        ","
      )} <span class="excl">(excl. BTW)</span><span aria-hidden="true">/</span> ${dataUnit}`;
      // }
    } else {
      // if(ism2=="true"){
      //   price[i].innerHTML =
      //  `€${priceExcludedVAT?.replace(".", ",")} per m<sup>2</sup> <span class="excl"> (excl. BTW)</span> `;
      // }else{
      price[i].innerHTML = `€${priceExcludedVAT?.replace(
        ".",
        ","
      )} <span class="excl"> (excl. BTW)</span>`;
      // }
    }
    // }, 1500);
  }
}

function functionForChecked() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");

  for (let i = 0; i < mainPrice.length; i++) {
    const mainDataValue = mainPrice[i]?.dataset?.mainprice;
    // setTimeout(() => {

    const isMeta = mainPrice[i]?.dataset?.ismeta;
    const ism2 = mainPrice[i]?.dataset?.ism2;
    if (isMeta == "true") {
      const metaVal = mainPrice[i]?.dataset?.metaval
        ?.slice(1)
        .replace(/,|\./g, function (match) {
          return match === "," ? "." : "";
        });

      const mainPriceExcludedVAT = parseFloat((metaVal * 121) / 100).toFixed(2);
      mainPrice[i].innerHTML = `€${mainPriceExcludedVAT?.replace(
        ".",
        ","
      )} <span>per m<sup>2</sup></span>`;
    } else {
      if (ism2 == "true") {
        mainPrice[i].innerHTML = `${mainDataValue} per m<sup>2</sup>`;
      } else {
        mainPrice[i].innerHTML = `${mainDataValue}`;
      }
    }
    // }, 1500);
  }
  for (let i = 0; i < price.length; i++) {
    const ism2 = mainPrice[i]?.dataset?.ism2;
    const dataValue = price[i]?.dataset?.price;
    // setTimeout(() => {
    const dataTest = price[i]?.dataset?.test;
    if (dataTest === "test") {
      // if(ism2=="true"){
      //    const dataUnit = document.getElementById("custom_unit").dataset.unit;
      // price[
      //   i
      // ].innerHTML = `${dataValue} <span aria-hidden="true">/</span> ${dataUnit} per m<sup>2</sup>`;
      // }else{
      const dataUnit = document.getElementById("custom_unit").dataset.unit;
      price[
        i
      ].innerHTML = `${dataValue} <span aria-hidden="true">/</span> ${dataUnit}`;
      // }
    } else {
      // if(ism2=="true"){
      //   price[i].innerText = dataValue +"per m<sup>2</sup>";
      // }else{
      price[i].innerText = dataValue;
      // }
    }
    // }, 1500);
  }
}

// on load
function functionUnchecked() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");

  for (let j = 0; j < mainPrice.length; j++) {
    const mainDataValue = mainPrice[j]?.dataset?.mainprice
      ?.slice(1)
      .replace(/,|\./g, function (match) {
        return match === "," ? "." : "";
      });
    const mainPriceExcludedVAT = parseFloat(
      (mainDataValue * 100) / 121
    ).toFixed(2);

    const isMeta = mainPrice[j]?.dataset?.ismeta;
    const ism2 = mainPrice[j]?.dataset?.ism2;
    console.log("ismeta", isMeta);
    if (isMeta == "true") {
      const metaVal = mainPrice[j]?.dataset?.metaval
        ?.slice(1)
        .replace(/,|\./g, function (match) {
          return match === "," ? "." : "";
        });

      const metaValReplaced = metaVal.replace(".", ",");
      mainPrice[
        j
      ].innerHTML = `€${metaValReplaced} <span>per m<sup>2</sup></span>`;
      // mainPrice[j].innerHTML = `€${metaVal}`;
    } else {
      if (ism2 == "true") {
        mainPrice[j].innerHTML = `€${mainPriceExcludedVAT?.replace(
          ".",
          ","
        )} per m<sup>2</sup> <span class="excl"> (excl. BTW)</span>`;
      } else {
        mainPrice[j].innerHTML = `€${mainPriceExcludedVAT?.replace(
          ".",
          ","
        )}<span class="excl"> (excl. BTW)</span>`;
      }
    }
  }
  for (let i = 0; i < price.length; i++) {
    const dataValue = price[i]?.dataset?.price?.slice(1)?.replace(",", ".");
    const priceExcludedVAT = parseFloat((dataValue * 100) / 121).toFixed(2);
    const dataTest = price[i]?.dataset?.test;

    if (dataTest === "test") {
      // if(ism2=="true"){
      //   const dataUnit = document.getElementById("custom_unit").dataset.unit;
      // price[i].innerHTML = `€${priceExcludedVAT?.replace(
      //   ".",
      //   ","
      // )} <span class="excl">(excl. BTW)</span><span aria-hidden="true">/</span> ${dataUnit} per m<sup>2</sup>`;
      // }else{
      const dataUnit = document.getElementById("custom_unit").dataset.unit;
      price[i].innerHTML = `€${priceExcludedVAT?.replace(
        ".",
        ","
      )} <span class="excl">(excl. BTW)</span><span aria-hidden="true">/</span> ${dataUnit}`;
      // }
    } else {
      // if(ism2=="true"){
      //    price[i].innerHTML =
      //   `€${priceExcludedVAT?.replace(".", ",")} per m<sup>2</sup> <span class="excl"> (excl. BTW)</span>`;
      // }else{
      price[i].innerHTML = `€${priceExcludedVAT?.replace(
        ".",
        ","
      )} <span class="excl"> (excl. BTW)</span>`;
      // }
    }
  }
}
function functionChecked() {
  const price = document.getElementsByClassName("custom_price");
  const mainPrice = document.getElementsByClassName("custom_main_price");
  for (let i = 0; i < mainPrice.length; i++) {
    const mainDataValue = mainPrice[i]?.dataset?.mainprice;
    const isMeta = mainPrice[i]?.dataset?.ismeta;
    const ism2 = mainPrice[i]?.dataset?.ism2;

    console.log("ismeta", isMeta);
    if (isMeta == "true") {
      console.log("hhhhhh");
      const metaVal = mainPrice[i]?.dataset?.metaval
        ?.slice(1)
        .replace(/,|\./g, function (match) {
          return match === "," ? "." : "";
        });

      console.log("metaVal", metaVal);
      const mainPriceExcludedVAT = parseFloat((metaVal * 121) / 100).toFixed(2);

      console.log("mainPriceExcludedVAT", mainPriceExcludedVAT);
      mainPrice[i].innerHTML = `€${mainPriceExcludedVAT?.replace(
        ".",
        ","
      )} <span>per m<sup>2</sup></span>`;
    } else {
      const dataTest = price[i]?.dataset?.test;
      if (ism2 == "true") {
        mainPrice[i].innerHTML = `${mainDataValue} per m<sup>2</sup>`;
      } else {
        mainPrice[i].innerText = mainDataValue;
      }
    }
  }
  for (let i = 0; i < price.length; i++) {
    const dataValue = price[i]?.dataset?.price;
    const dataTest = price[i]?.dataset?.test;
    if (dataTest === "test") {
      //  if(ism2=="true"){
      //    const dataUnit = document.getElementById("custom_unit").dataset.unit;
      // price[
      //   i
      // ].innerHTML = `${dataValue} <span aria-hidden="true">/</span> ${dataUnit} per m<sup>2</sup>`;
      //  }else{
      const dataUnit = document.getElementById("custom_unit").dataset.unit;
      price[
        i
      ].innerHTML = `${dataValue} <span aria-hidden="true">/</span> ${dataUnit}`;
      // }
    } else {
      // if(ism2=="true"){
      //    price[i].innerText = dataValue +"per m<sup>2</sup>";
      // }else{
      price[i].innerText = dataValue;
      // }
    }
  }
}
